import * as types from "../actionTypes";

export const setSalesMarketingByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_SALES_MARKETING_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};
export const setSalesMarketingByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_SALES_MARKETING_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceSalesMarketingYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_SALES_MARKETING_BY_YEAR,
      key,
      payload,
    });
  };
};

export const resetSalesMarketingReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_SALES_MARKETING_REDUCER,
    });
  };
};
